module.exports = __webpack_public_path__ + "assets/img/kefu.4ec75d29.png";